(function (angular) {
    'use strict';
    angular.module('SMART2').
        directive('actionMenuCollection', ['$q', '$http', '$injector', '$templateCache', 'scriptCache', 'APPCONSTANTS', 'dependencyResolver', actionMenuCollectionFunc]).directive('actionMenu', ['$timeout', '$http', '$compile', '$templateCache', 'APPCONSTANTS', 'routeSvc', 'actionCommunicator', actionMenuFunc]);;
    function actionMenuCollectionFunc($q, $http, $injector, $templateCache, scriptCache, APPCONSTANTS, dependencyResolver) {
        return {
            restrict: "E", transclude: true,
            scope: {
                actionCollection: "="
            },
            template: '<action-menu ng-repeat="card in actionCollection.config track by $index" action-linker="card" ng-if="card.isJSLoaded"></action-menu>',
            link: function (scope, element, attrs) {
                var ver = "?ver=" + APPCONSTANTS.userPreferences.ScriptVersion,
                minValue = "", defaultConfig = typeof actionMenuDefConfig !== 'undefined' ? actionMenuDefConfig : null;
                if (deployType.toLowerCase() !== "dev") {
                    minValue = ".min";
                }
				var bldVer = typeof wsBuildVersion !== 'undefined' ? (wsBuildVersion + "/") : "";
                function get(docTypeIds) {
                    var dependencies = [];
                    _.each(docTypeIds, function (o) {
                        var documentTypeName = APPCONSTANTS.docType[o].toUpperCase();
                        if ((defaultConfig[o.toString()]) || ((typeof templatePrvConfig !== 'undefined' && templatePrvConfig[o] && !templatePrvConfig[o].disable))) {
                            dependencies.push(APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/distribution/" + bldVer + "workspace.dist/documentTemplates/" + documentTypeName + "/" + documentTypeName + minValue + ".js" + ver);
                            dependencies.push(APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/distribution/" + bldVer + "workspace.dist/documentTemplates/" + documentTypeName + "/" + documentTypeName + "LazyLoadedTemplate" + minValue + ".js" + ver);
                            //dependencies.push(APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/distribution/workspace.dist/documentTemplates/" + documentTypeName + "/" + documentTypeName + minValue + ".js" + ver);
                            //dependencies.push(APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/distribution/workspace.dist/documentTemplates/" + documentTypeName + "/" + documentTypeName + "LazyLoadedTemplate" + minValue + ".js" + ver);
                        }
                    });
                    return dependencyResolver.resolveDependencies($q, $http, $injector, $templateCache, scriptCache, dependencies);
                }
                if (scope.actionCollection) {
                    scope.actionCollection.getDocumentFile = function (docTypeIds) {
                        get(docTypeIds).then((function (rVal) {
                            return function (data) {
                                setActionMenu(rVal);
                            }
                        })(docTypeIds));
                    };
                    if (scope.actionCollection.isDocumentLoaded) {
                        var docTypeIds = _.pluck(scope.actionCollection.config, 'docType');
                        scope.actionCollection.getDocumentFile(docTypeIds);
                    }
                }

                function setActionMenu(docTypeIds) {
                    _.each(docTypeIds, function (o, i) {
                        var indx = _.findIndex(scope.actionCollection.config, {
                            'docType': o
                        });
                        if (indx > -1) {
                            scope.actionCollection.config[indx]['isJSLoaded'] = true;
                        }
                    });
                }
            }
        };
    }

    function actionMenuFunc($timeout, $http, $compile, $templateCache, APPCONSTANTS, routeSvc, actionCommunicator) {
        return {
            restrict: "E",
            scope: {
                actionLinker: "="
            },
            link: function (scope, element, attrs) {
                var onDemandLoadedTemplateForProduct = null;
                function includeOnDemandTemplate(url, docType) {
                    if (url) {
                        element.append($compile("<div ng-if='actionLinker.isTmplActive'>" + $templateCache.get(url) + "</div>")(scope,
                          (function (rDocType) {
                              return function (c, scope) {
                                  $timeout(function () { actionCommunicator.productActivated(rDocType); })
                              }
                          })(docType)
                        ));
                        onDemandLoadedTemplateForProduct = docType;
                    }
                };
                function clickActionMenuPhase(result, e) {
                    e.stopPropagation();
                    if (typeof result == "object" && !result.disable) {
                        (result.url) ? redirection(result.url) : (scope.actionLinker.callback) ? scope.actionLinker.callback(result) : null;
                    }
                }

                function redirection(url) {
                    routeSvc.goTo(url);
                }

                function removeOnDemandCreatedTemplate() {
                    onDemandLoadedTemplateForProduct = null;
                    element.find("[ng-controller]").remove();
                }
                function evaluateLinkerBindings(menuList) {
                    _.each(menuList, function (value, key, object) {
                        expressionBinder(value, key, object);
                        _.each(value, function (value, key, object) {
                            _.each(value, function (value, key, object) {
                                expressionBinder(value, key, object);
                            })
                        })
                    });
                    return menuList;
                }

                function expressionBinder(value, key, object) {
                    if (typeof value === "string" && value.indexOf("(") > -1 && angular.isFunction(scope.actionLinker[value.split("(")[0]])) {
                        object[key] = scope.actionLinker[value.split("(")[0]](object);
                    }
                }

                function setActiveProductDetail(product) {
                    var defaultConfig = typeof actionMenuDefConfig !== 'undefined' ? actionMenuDefConfig : null;
                    var config = angular.copy((typeof _clientSpecificActionConfigSettings !== 'undefined' && _clientSpecificActionConfigSettings[product.docType]) ? _clientSpecificActionConfigSettings[product.docType] : defaultConfig ? defaultConfig[product.docType] : defaultConfig);
                    if (config) {
                        scope.actionLinker.show = config.show;
                        if (product.docType != onDemandLoadedTemplateForProduct) {
                            removeOnDemandCreatedTemplate();
                            includeOnDemandTemplate(config.onDemandTemplate, product.docType);
                        }
                    }
                };
                function setDocumentActionMenuList(documents, docType) {
                    documents = evaluateLinkerBindings(documents);
                    if (!scope.actionLinker.documentActionList) {
                        scope.actionLinker.documentActionList = documents;
                    }
                    else {
                        _.each(documents, function (value, key, object) {
                            scope.actionLinker.documentActionList[key] = value;
                        });
                    }
                };

                function openMenu(docType, item) {
                    if (!_.has(scope.actionLinker.documentActionList, item.DocumentCode)) {
                        if (typeof scope.actionLinker.menuClick == 'function')
                            scope.actionLinker.menuClick(docType, item, setItemActionMenu);
                    }
                }

                function setItemActionMenu(docType, docCode, result) {
                    if (result) {
                        _.each(result, function (value, key, object) {
                            _.each(value, function (value, key, object) {
                                expressionBinder(value, key, object);
                            })
                        })
                        scope.actionLinker.documentActionList[docCode] = result[docCode];
                    }
                }

                if (scope.actionLinker) {
                    if (!_.has(scope.actionLinker, "documentActionList")) {
                        setActiveProductDetail(scope.actionLinker);
                    }
                    scope.actionLinker.setDocumentActionMenu = function (documents, docType) {
                        setDocumentActionMenuList(documents, docType);
                    }
                    scope.actionLinker.onActionMenuClick = function (result, e) {
                        clickActionMenuPhase(result, e);
                    }
                    scope.actionLinker.openActionMenu = function (docType, item) {
                        openMenu(docType, item);
                    }
                }
            }
        };
    }
})(angular);
